import Link from "next/link";
import { useEffect } from "react";
import { prefix } from "../../utils/utils";
export default function NewsFilters({
  categories,
  selectedFilter,
  setSelectedFilter,
  translations,
}) {
  const currentPath =
    typeof window !== "undefined" ? window.location.pathname : "";

  return (
    <div className="container-custom py-20 1024:py-40 bg-gray-200">
      <div className="flex flex-col gap-y-15">
        <span className="text-xxs font-medium leading-115 tracking-05">
          {translations["filter_news_by"]}
        </span>
        <div className="flex flex-wrap gap-8 640:gap-x-12">
          <Link
            href={"?"}
            as={"?"}
            onClick={() => {
              setSelectedFilter("all-posts");
            }}
            scroll={false}
            className={`block rounded-xxxs px-8 py-6 media-hover:hover:cursor-pointer ${
              selectedFilter === "all-posts"
                ? "bg-gray-700 text-white border border-solid border-gray-700"
                : "bg-gray-100 text-gray-900 border border-solid border-gray-300 media-hover:hover:bg-gray-700 media-hover:hover:text-white media-hover:hover:border-transparent duration-300"
            }`}
            aria-label={translations["all_posts"] || "All Posts"}
          >
            <span className="text-xxs font-medium">
              {translations["all_posts"]}
            </span>
          </Link>
          {categories.data.length &&
            categories.data.map((category, index) => (
              <Link
                key={index}
                href={`?category=${category.attributes.slug}`}
                as={`?category=${category.attributes.slug}`}
                onClick={() => {
                  setSelectedFilter(category.attributes.slug);
                }}
                scroll={false}
                aria-label={category.attributes.title || "Category"}
                className={`block rounded-xxxs px-8 py-6 media-hover:hover:cursor-pointer ${
                  selectedFilter === category.attributes.slug
                    ? "bg-gray-700 text-white border border-solid border-gray-700"
                    : "bg-gray-100 text-gray-900 border border-solid border-gray-300 media-hover:hover:bg-gray-700 media-hover:hover:text-white media-hover:hover:border-transparent duration-300"
                }`}
              >
                <span className="text-xxs font-medium">
                  {category.attributes.title}
                </span>
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
}
